// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-eXPj9u","elementMeasure":"elementMeasure-wjkW91"};